import type { HttpPort } from "~/lib/http";

export interface StudentVotingSession {
  id: string;
  status: "open" | "closed" | "results";
}

export interface StudentVotingOption {
  id: string;
  title: string;
  description?: string | null;
  category_name?: string | null;
  color?: string | null;
  icon?: string | null;
  vote_count: number;
}

export interface PreviousGoal {
  title: string;
  rank?: number | null;
}

export interface StudentVotingSnapshot {
  session: StudentVotingSession | null;
  options: StudentVotingOption[];
  hasVoted: boolean;
  userVotes: string[];
  participationCount: number;
  totalStudents: number;
  lastWeekGoals: PreviousGoal[];
}

export function createStudentVotingModule(http: HttpPort, token: string) {
  return {
    async load(classId: string): Promise<StudentVotingSnapshot> {
      const value = await http.request<Partial<StudentVotingSnapshot>>({ path: `/voting/${classId}/current`, token });
      return {
        session: value.session ?? null,
        options: value.options ?? [],
        hasVoted: value.hasVoted ?? false,
        userVotes: value.userVotes ?? [],
        participationCount: value.participationCount ?? 0,
        totalStudents: value.totalStudents ?? 0,
        lastWeekGoals: value.lastWeekGoals ?? []
      };
    },
    async vote(classId: string, sessionId: string, optionIds: string[]): Promise<void> {
      const selected = [...new Set(optionIds)].slice(0, 3);
      if (!selected.length) throw new Error("Bitte wähle mindestens ein Ziel aus.");
      await http.request({ path: `/voting/${classId}/vote`, method: "POST", token, body: { sessionId, optionIds: selected } });
    }
  };
}

export type StudentVotingModule = ReturnType<typeof createStudentVotingModule>;
